<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><a class="page" id="piv"></a>Copyright © 2019 by University of Massachusetts Press</p>
<p class="crt">All rights reserved</p>
<p class="crtf">ISBN 978-1-61376-721-4 (ebook)</p>
<p class="crtf">Cover design by Milenda Nan Ok Lee</p>
<p class="crt">Cover photo: <i>Maria Baldwin</i>. Cambridge Historical Commission, Cambridge Public Library Collection.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Weiler, Kathleen, author.</p>
<p class="cip">Title: Maria Baldwin’s worlds : a story of Black New England and the fight</p>
<p class="cip">for racial justice / Kathleen Weiler.</p>
<p class="cip">Other titles: Story of Black New England and the fight for racial justice</p>
<p class="cip">Description: Amherst, MA : University of Massachusetts Press, [2019] | Includes bibliographical references and index. | Summary: “Maria Baldwin (1856–1922) held a special place in the racially divided society of her time, as a highly respected educator at a largely white New England school and an activist who carried on the radical spirit of the Boston area’s internationally renowned abolitionists from a generation earlier. African American sociologist Adelaide Cromwell called Baldwin “the lone symbol of Negro progress in education in the greater Boston area” during her lifetime. Baldwin used her respectable position to fight alongside more radical activists like William Monroe Trotter for full citizenship for fellow members of the black community. And, in her professional and personal life, she negotiated and challenged dominant white ideas about black womanhood. In Maria Baldwin’s Worlds, Kathleen Weiler reveals both Baldwin’s victories and what fellow activist W. E. B. Du Bois called her “quiet courage” in everyday life.”—Provided by publisher.</p>
<p class="cip">Identifiers: LCCN 2019020708 (print) | LCCN 2019022357 (ebook) | ISBN 9781625344779 (hardcover) | ISBN 9781625344786 (pbk.)</p>
<p class="cip">Subjects: LCSH: Baldwin, Maria, 1856–1922. | African American intellectuals—Massachusetts—Cambridge--Biography. | African American women school principals—Massachusetts—Cambridge—Biography. | Professor Agassiz’ School (Cambridge, Mass.) —Biography. | African American civil rights workers—Massachusetts—Cambridge—Biography. | African Americans—Civil rights—Massachusetts--Boston Region—History—19th century. | Single women—Massachusetts—Cambridge—Biography. | Boston Region (Mass.) —Race relations—History—19th century. Classification: LCC E185.89.I56 W45 2019 (print) | LCC E185.89.I56 (ebook) | DDC 370.92 [B]—dc23</p>
<p class="cip">LC record available at https://lccn.loc.gov/2019020708</p>
<p class="cip">LC ebook record available at https://lccn.loc.gov/2019022357</p>
<p class="cipf">British Library Cataloguing-in-Publication Data</p>
<p class="cip">A catalog record for this book is available from the British Library</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Weiler0005.vue?2fd36aa1